module.exports = __webpack_public_path__ + "media/robin.d35fe497.wav";